var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "interment-file-wrapper",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.openFile.apply(null, arguments)
        },
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "document-name text-truncate" }, [
        _c("p", { staticClass: "name" }, [_vm._v(_vm._s(_vm.filename))]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "document-icon" }, [
      _c("img", {
        attrs: {
          loading: "lazy",
          src: "https://demo-us.chronicle.rip/assets/images/document_icon.svg",
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }